import {
  Tooltip,
  AlertTriangleIcon,
  WarningCircleIcon,
  CheckIcon,
} from "@stacklet/ui";

interface Props {
  status: "success" | "warning" | "error";
  message?: string;
}

export function StatusIcon({ status, message }: Props) {
  return (
    <>
      {status === "error" ? (
        <Tooltip title={message || ""}>
          <WarningCircleIcon
            aria-label="error"
            className="mx-xxs size-icon-s fill-negative-600"
            data-testid="error-icon"
          />
        </Tooltip>
      ) : null}
      {status === "warning" ? (
        <Tooltip title={message || ""}>
          <AlertTriangleIcon
            aria-label="warning"
            className="mx-xxs size-icon-s text-warning-700"
            data-testid="warning-icon"
          />
        </Tooltip>
      ) : null}

      {status === "success" ? (
        <Tooltip title={message || ""}>
          <CheckIcon
            aria-label="success"
            className="mx-xxs size-icon-s text-positive-700"
            data-testid="success-icon"
          />
        </Tooltip>
      ) : null}
    </>
  );
}
